var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Base } from "./base";
var Avatar = /** @class */ (function (_super) {
    __extends(Avatar, _super);
    function Avatar(source, width, height, onClickAction, backgroundColor, ariaLabel) {
        if (backgroundColor === void 0) { backgroundColor = null; }
        if (ariaLabel === void 0) { ariaLabel = null; }
        var _this = _super.call(this) || this;
        var avatar;
        // default avatar
        if (source === null) {
            avatar = document.createElement('div');
            avatar.style.borderRadius = "".concat(width, "px");
            avatar.style.backgroundColor = backgroundColor;
        }
        else {
            var image = document.createElement('img');
            image.src = source;
            avatar = image;
        }
        avatar.style.width = "".concat(width, "px");
        avatar.style.height = "".concat(height, "px");
        avatar.style.display = 'block';
        avatar.style.margin = 'auto';
        if (onClickAction) {
            avatar.style.cursor = 'pointer';
            avatar.setAttribute('role', 'button');
            avatar.tabIndex = 0;
            if (ariaLabel) {
                avatar.setAttribute('aria-label', ariaLabel);
            }
            avatar.addEventListener('keydown', function (event) {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    avatar.click();
                }
            });
            avatar.onclick = onClickAction;
        }
        _this.self = avatar;
        return _this;
    }
    return Avatar;
}(Base));
export { Avatar };
